<template>
  <div>
    <the-hero-section :title="title" :imgLink="imgLink" />
    <vertical-divider />
    <section id="about-us" class="extra-padding grey lighten-4">
      <v-container>
        <v-row justify="center">
          <v-col cols="11" md="12" class="mx-auto">
            <p class="text-justify font-weight-light">
              <span class="primary--text font-weight-bold">
                ARGECAM S.R.L.</span
              >
              es una empresa vial especializada en movimiento de suelo y
              excavaciones de grandes volúmenes afianzada en el rubro con más de
              15 años en el mercado de la construcción, contamos con los equipos
              viales necesarios para que la obra se efectúe de forma eficiente,
              utilizando la última tecnología en nuestros equipos, invirtiendo
              en capacitación de nuestros profesionales e infraestructura, así
              continuaremos avanzando respetando nuestros ideales y ayudando a
              convertir los proyectos en realidades concretas.
            </p>
            <p class="text-justify font-weight-light">
              Desde su creación, la empresa ha desarrollado su actividad en
              tareas de movimiento de suelos, excavaciones, demoliciones,
              alquiler de equipos viales siendo contratada tanto en el ámbito
              privado como en el estatal.
            </p>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid class="gradiente mt-0 pa-0">
        <v-row justify="center" class="ancho mx-auto">
          <v-col cols="12" md="4" v-for="item in items" :key="item.i">
            <v-card class="elevation-0 transparent">
              <v-card-title class="text-uppercase white--text">
                {{ item.title }}
              </v-card-title>
              <v-card-text
                class="text-justify font-weight-light mt-n3 white--text"
              >
                {{ item.texto }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row>
          <v-col cols="12" class="mx-auto">
            <v-card class="elevation-0 grey lighten-4">
              <v-card-title class="text-uppercase primary--text"
                >objetivos</v-card-title
              >
              <v-card-text class="my-0 py-2">
                <v-alert
                  v-for="o in objetivos"
                  :key="o"
                  border="left"
                  color="accent2"
                  dense
                  prominent
                  text
                  class="elevation-3"
                  >{{ o }}</v-alert
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "About",
  components: {
    TheHeroSection: () => import("@/components/TheHeroSection"),
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue")
  },
  data: () => ({
    title: "Sobre Nosotros",
    imgLink: "section-about.jpeg",
    items: [
      {
        title: "misión",
        texto:
          "Nuestra misión es transformar toda la experiencia adquirida en beneficio de mejores obras, a la vanguardia en la incorporación de nuevas tecnologías, satisfaciendo y superando las expectativas de nuestros clientes y comitentes, desarrollando un compacto y comprometido grupo humano, identificado con el futuro de la Compañía, y en condiciones de aceptar el más exigente desafío."
      },
      {
        title: "visión",
        texto:
          "Nuestra visión es consolidar nuestro prestigio empresarial en todos los rubros de la construcción, logrando la excelencia de nuestras obras y servicios."
      },
      {
        title: "valores",
        texto:
          "Trabajamos con pasión, dedicación y entusiasmo, también con conciencia e integridad, y la más alta calidad."
      }
    ],
    objetivos: [
      "El objetivo más importante de la compañía es mantener la confiabilidad, credibilidad y buen nombre y por ello hace frente a cada uno de sus trabajos con el compromiso de satisfacer a sus clientes superando sus expectativas.",
      "Establecer y mantener un ambiente seguro y saludable, realizando nuestras actividades de manera responsable.",
      "Trabajar en la prevención de accidentes mediante la implementación de condiciones seguras de trabajo.",
      "Cumplir con todos los requisitos legales y reglamentarios relacionados con nuestra actividad.",
      "Satisfacer los requisitos, necesidades y expectativas de nuestros clientes.",
      "Ser competitivos y líderes en nuestro ámbito de actuación.",
      "Asistir al cliente mediante propuestas de mejora.",
      "Capacitarnos y buscar nuevas tecnologías para mejorar nuestro trabajo.",
      "Establecer y fijar objetivos para mejorar continuamente."
    ]
  })
};
</script>

<style scoped>
.divider {
  border: 1px solid red;
  left: 0;
}

.ancho {
  width: 70%;
  min-height: 350px;
  height: auto;
  padding: 3em 0;
}
.gradiente {
  background-image: linear-gradient(
    to bottom,
    #171f2e,
    #1a2332,
    #1e2736,
    #212c3b,
    #25303f
  );
}
</style>
